import { render, staticRenderFns } from "./VAST2014.md?vue&type=template&id=27410f82&"
import script from "./VAST2014.md?vue&type=script&lang=js&"
export * from "./VAST2014.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports